export default {
  SET_STEPS(state, steps) {
    state.steps = steps
  },
  REMOVE_STEPS(state, itemId) {
      const roleIndex = state.steps.datas.findIndex((u) => u.id == itemId)
      state.steps.datas.splice(roleIndex, 1)
  },
  SELECTED_STEPS(state,data){
    state.steps.datas = []
    state.steps.total = 1;
    state.steps.per_page = 1;
    state.steps.datas.push(data)
  },
  SET_AUTOCOMPLETE_DATA(state,data){
    state.autocomplete_data = data
  },
  EDIT_ITEM(state,data){
    state.elomark_user = data
  },
  ADD_ITEM(state,data){
    state.elomark_user = data
  },
}
